"use client";

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { AuthPage } from "@/components/auth-page";

export const Route = createFileRoute("/accept-invitation")({
	component: AcceptInvitationPage,
	ssr: false,
	validateSearch: (search: Record<string, unknown>) => ({
		id: typeof search.id === "string" ? search.id : "",
		invitationId:
			typeof search.invitationId === "string" ? search.invitationId : "",
		redirectTo: typeof search.redirectTo === "string" ? search.redirectTo : "",
	}),
});

function AcceptInvitationPage() {
	const navigate = useNavigate();
	const { id, invitationId, redirectTo } = Route.useSearch();

	useEffect(() => {
		if (!(id && !invitationId)) {
			return;
		}

		navigate({
			replace: true,
			search: {
				id: "",
				invitationId: id,
				redirectTo,
			},
			to: "/accept-invitation",
		});
	}, [id, invitationId, navigate, redirectTo]);

	return <AuthPage view="ACCEPT_INVITATION" />;
}
